import Req from '../../$axios';

const serviceModule = {
  // 工作台页面使用,获取部门下业务分类
  getDepartmentProjectfolder(params) {
    return Req(
      {
        url: 'project/departmentlist/',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 获取某个部门某个业务下的项目列表
  getProjectListByDepartment(params) {
    return Req(
      {
        url: 'project/departmentproject/',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 获取项目列表
  getProjectList(params) {
    return Req(
      {
        url: 'project/index/',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 根据名称搜索项目
  getSearchProjects(params) {
    return Req(
      {
        url: 'project/searchProjectsByTitle',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 添加项目
  addProject(params) {
    return Req(
      {
        url: 'project/addproject/',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 编辑项目
  editProject(params) {
    return Req(
      {
        url: 'project/updateproject/',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 删除项目
  delProject(params) {
    return Req(
      {
        url: 'project/deleteproject/',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 获取项目成员
  getProjectMember(params) {
    return Req(
      {
        url: 'project/getprojectmember/',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 更新项目成员
  updateProjectMember(params) {
    return Req(
      {
        url: 'project/updateprojectmember/',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 删除项目成员
  deleteProjectMember(params) {
    return Req(
      {
        url: 'project/deleteprojectmember/',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 设置项目成员的权限
  updateprojectmemberrole(params) {
    return Req(
      {
        url: 'project/updateprojectmemberrole/',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 移动项目
  updateorderby(params) {
    return Req(
      {
        url: 'project/updateorderby/',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 删除项目
  deleteproject(params) {
    return Req(
      {
        url: 'project/deleteproject/',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 项目下的文件
  getProjectFolderlist(params) {
    return Req(
      {
        url: 'projectlist/index/',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 添加项目业务分类文件夹
  addProjectFolder(params) {
    return Req(
      {
        url: 'projectlist/addprojectlist/',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 更新项目业务分类文件夹
  updateProjectFolder(params) {
    return Req(
      {
        url: 'projectlist/updateprojectlist/',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 删除项目业务分类文件夹
  delProjectFolder(params) {
    return Req(
      {
        url: 'projectlist/deleteprojectlist/',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 获取项目的未读消息列表
  getProjectUnreadMessage(params) {
    return Req(
      {
        url: 'messagelog/index/',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 将消息设置为已读
  setProjectMessageIsRead(params) {
    return Req(
      {
        url: 'messagelog/readmessage/',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 根据项目状态查询项目 [获取项目,冻结项目,归档项目,删除项目]
  getProjectByStatus(params) {
    return Req(
      {
        url: 'project/getallproject/',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 激活项目
  activateProject(params) {
    return Req(
      {
        url: 'archived/openproject/',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 归档项目
  archiveProject(params) {
    return Req(
      {
        url: 'archived/project/',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 查询所有的归档项目列表
  getArchiveProjectList(params) {
    return Req(
      {
        url: 'archived/index/',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 激活项目,可以激活归档,冻结的项目
  activeProjectStatus(params) {
    return Req(
      {
        url: 'project/activeprojectstatus/',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  //设置当前任务及子任务未读消息已读(旧)
  setTaskAndChildrenTaskMessageRead(params) {
    return Req(
      {
        url: 'messageLog/setTaskAndChildrenTaskMessageRead',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  //设置当前任务及子任务未读消息已读(新)
  setNewTaskAndChildrenTaskMessageRead(params) {
    return Req(
      {
        url: 'projectMessages/setTaskAndChildrenTaskMessageRead',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  //获取项目详情
  getProjectDetail(params) {
    return Req(
      {
        url: 'project/read',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  getTheNumberOfProjectDifferentStates(params) {
    return Req(
      {
        url: 'project/getTheNumberOfProjectDifferentStates',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  updateCrossProjectsBackground(params) {
    // 跨团队项目背景
    return Req(
      {
        url: '/crossprojects/updateCrossProjectsBackground',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  updateProjectBackground(params) {
    // 项目背景
    return Req(
      {
        url: '/project/updateProjectBackground',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  indexProjectTemplates(params) {
    // 项目背景
    return Req(
      {
        url: '/projectTemplates/index',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  departmentProjectByV2(params) {
    return Req(
      {
        url: '/project/departmentProjectByV2',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  getTheNumberOfProjectDifferentStatesByV2(params) {
    return Req(
      {
        url: '/project/getTheNumberOfProjectDifferentStatesByV2',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  projectTagList(params) {
    return Req(
      {
        url: '/projectMemberLabel/index',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  projectTagSave(params) {
    return Req(
      {
        url: '/projectMemberLabel/save',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  saveOrUpadteProjectMemberHasLabel(params) {
    return Req(
      {
        url: '/projectMemberLabel/saveOrUpadteProjectMemberHasLabel',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  projectTagDel(params) {
    return Req(
      {
        url: '/projectMemberLabel/delete',
        method: 'delete',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  }
}

export default {
  ...serviceModule
};
